import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isShow: false,
  status: '',
  text: "Continue",
  icon: '',
  buttonClicked: false,
  error: false,
  buttonNoClick: false,
  buttonYesClick: false,
  buttonBackClicked: false,
  buttonBackIsShow: false
};

const buttonSlice = createSlice({
  name: 'button',
  initialState,
  reducers: {
    setIsShowButton: (state, action) => {
      state.isShow = action.payload;
    },
    setStatusButton: (state, action) => {
      state.status = action.payload;
    },
    setTextButton: (state, action) => {
      state.text = action.payload;
    },
    setIconButton: (state, action) => {
      state.icon = action.payload;
    },
    setErrorButton: (state, action) => {
      state.error = action.payload;
    },
    setButtonClick: (state, action) => {
      state.buttonClicked = action.payload;
    },
    setButtonNoClick: (state, action) => {
      state.buttonNoClicked = action.payload;
    },
    setButtonYesClick: (state, action) => {
      state.buttonYesClicked = action.payload;
    },
    setButtonBackClick: (state, action) => {
      state.buttonBackClicked = action.payload;
    },
    setButtonBackIsShow: (state, action) => {
      state.buttonBackIsShow = action.payload;
    },
  },
});

export const {
  setIsShowButton,
  setStatusButton,
  setTextButton,
  setIconButton,
  setErrorButton,
  setButtonClick,
  setButtonNoClick,
  setButtonYesClick,
  setButtonBackClick,
  setButtonBackIsShow
} = buttonSlice.actions;

export default buttonSlice.reducer;